import { isNull } from 'utils/tsHelpers';
import { useDebugValue } from 'react';
import { ElementType, useIndex } from '../../../contexts/elementIndex';
import { useClauseConditionsWatch } from '../watchers/useClauseConditionsWatch';

export const useIsLastCondition = () => {
  const index = useIndex(ElementType.condition);
  if (isNull(index)) {
    throw new Error('Could not determine if condition is last: no condition index in context');
  }
  const conditions = useClauseConditionsWatch();
  const isLastCondition = index === conditions.length - 1;
  useDebugValue(isLastCondition);
  return isLastCondition;
};
